import Members from './members'
import Location from './location'
import Form from './form'
import Photo from './photo'
import Hero from './hero'
import studioRequest from 'request/join-us/query-studio'

export default function Apply() {
  const t = useI18n()
  const { state, mutate } = useStatic({ studio: null, visible: false })

  h.openJoinUsApply = async studioId => {
    state.studio = await studioRequest({ studioId })
    state.studio.showableStylists = state.studio.showableStylists.filter(stylist => !stylist.isStudioAccount)
    state.visible = true
    mutate()
    mkt.joinUsContactUs(studioId)
  }

  const closePanel = () => {
    state.visible = false
    mutate()
  }

  const renderBody = () => {
    if (!state.visible) return
    return <Body state={ state } closePanel={ closePanel }/>
  }

  return (
    <C.Modal
      visible={ state.visible }
      close={ closePanel }
      noPadding
    >
      <C.ModalHeader title={ t('page:joinUs.studios.title') }>
        { renderBody() }
      </C.ModalHeader>
    </C.Modal>
  )
}

const Body = ({ state }) => <div className='flex flex-col overflow-scroll'>
  <Hero studio={ state.studio }/>
  <Hr />
  <Location studio={ state.studio } />
  <Hr />
  <Photo studio={ state.studio } />
  <Hr/>
  <Members studio={ state.studio } />
  <Hr/>
  <div className='mt-5 mb-10'><Form studioId={ state.studio.id }/></div>

</div>

const Hr = () => (
  <div className='pb-9 mx-5'>
  </div>
)